import React from 'react';

const Text = ({ children, variant = 'body', className = '' }) => {
  const variants = {
    body: 'text-base text-gray-600',
    small: 'text-sm text-gray-600',
    muted: 'text-sm text-gray-400'
  };
  
  return (
    <p className={`${variants[variant]} ${className}`}>
      {children}
    </p>
  );
};

export default Text;